import { computed, ref, watch } from 'vue';
import { normalizeTree } from '@/lib/goal/normalize-tree';

export function useCascadeData(goalTreeService, renderedItemsLimit, loaderSvc) {
  const normalized = computed(() => {
    const data = goalTreeService.goalTree;
    return [normalizeTree('_children')].reduce((res, m) => {
      res = m(res);
      return res;
    }, data.value);
  });

  const renderedItems = ref(renderedItemsLimit.value);
  const goalTree = computed(() => normalized.value.slice(0, renderedItems.value));

  const hasMore = computed(() => normalized.value.length > renderedItems.value);
  const loadMore = () => {
    renderedItems.value += renderedItemsLimit.value;
    if (hasMore.value) {
      return;
    }
    loaderSvc.loadMore();
  };

  watch(() => loaderSvc.viewChangedLoading.value, (val, oldVal) => {
    if (oldVal === false && val === true) {
      renderedItems.value = renderedItemsLimit.value;
    }
  });

  return { goalTree, loadMore, hasMore: computed(() => hasMore.value || loaderSvc.hasMore.value) };
}
